import styled, { css } from "styled-components"

import { Color, TextSize, Transition } from "~/consts/style-mixins"

interface Props {
  type: keyof typeof Type
  iconPath: string
  name: string
  label?: string
  description?: string
  className?: string
}

interface StyledProps {
  type?: keyof typeof Type
  iconImageStyleByType?: any
  nameStyleByType?: any
  textWrapperStyleByType?: any
}

export const Type = {
  xLarge: "xLarge",
  Large: "Large",
  Medium: "Medium",
  Small: "Small",
}

const User = ({ type, iconPath, name, label, description, className }: Props) => {
  return (
    <StyledUserWrapper type={type} className={className}>
      <StyledIconImage
        src={iconPath}
        alt={`${name}のアイコン`}
        type={type}
        iconImageStyleByType={iconImageStyleByType[type]}
      />
      <StyledTextWrapper type={type}>
        {label && <StyledLabel>{label}</StyledLabel>}
        <StyledName nameStyleByType={nameStyleByType[type]}>{name}</StyledName>
        {description && <StyledDescription type={type}>{description}</StyledDescription>}
      </StyledTextWrapper>
    </StyledUserWrapper>
  )
}

const iconImageStyleByType = {
  xLarge: css`
    width: 80px;
    height: 80px;
  `,
  Large: css`
    width: 64px;
    height: 64px;
    margin-right: 12px;
  `,
  Medium: css`
    width: 48px;
    height: 48px;
    margin-right: 8px;
  `,
  Small: css`
    width: 32px;
    height: 32px;
    margin-right: 8px;
  `,
}

const nameStyleByType = {
  xLarge: css`
    font-size: ${TextSize.M}px;
  `,
  Large: css`
    font-size: ${TextSize.M}px;
  `,
  Medium: css`
    font-size: ${TextSize.S}px;
  `,
  Small: css`
    display: none;
  `,
}

const StyledUserWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  &:hover {
    img {
      border: 1px solid ${Color.Primary};
    }
  }
  ${({ type }: StyledProps) => css`
    ${type === Type.xLarge &&
    `
      flex-direction: column;
    `}
  `}
`

const StyledIconImage = styled.img`
  border: 1px solid ${Color.BorderGray};
  border-radius: 50%;
  object-fit: cover;
  font-size: ${TextSize["2XS"]}px;
  background: white;
  ${Transition.Hover};
  ${({ type, iconImageStyleByType }: StyledProps) => css`
    ${type === Type.xLarge &&
    `
      margin-bottom: 8px;
    `}
    ${iconImageStyleByType}
  `}
`

const StyledTextWrapper = styled.div`
  overflow: hidden;
  ${({ type }: StyledProps) => css`
    ${type === Type.xLarge &&
    `
      width: 100%;
      text-align: center;
      line-height: 140%;
    `}
    ${type === Type.Large &&
    `
      width: calc(100% - 80px);
    `}
    ${type === Type.Medium &&
    `
      width: calc(100% - 56px);
    `}
    ${type === Type.Small &&
    `
      width: calc(100% - 40px);
    `}
  `}
`

const StyledLabel = styled.div`
  margin-bottom: 4px;
  font-size: ${TextSize.XS}px;
  font-weight: bold;
  color: ${Color.Primary};
`

const StyledName = styled.div`
  margin-bottom: 6px;
  font-weight: bold;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: ${Color.Black};
  ${({ nameStyleByType }: StyledProps) => css`
    ${nameStyleByType}
  `}
`

const StyledDescription = styled.div`
  font-size: ${TextSize.XS}px;
  text-align: left;
  color: ${Color.LightGray};
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  ${({ type }: StyledProps) => css`
    ${type === Type.Small &&
    `
      font-size: ${TextSize.S}px;
      color: ${Color.Black};
    `}
    ${type === Type.xLarge &&
    `
      height: 32px;
      white-space: normal;
      text-align: center;
      line-height: 140%;
    `}
  `}
`

export default User
